var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4L18 1M18 1L21 4M18 1V7M15 19V17.8C15 16.1198 15 15.2798 14.673 14.638C14.3854 14.0735 13.9265 13.6146 13.362 13.327C12.7202 13 11.8802 13 10.2 13H5.8C4.11984 13 3.27976 13 2.63803 13.327C2.07354 13.6146 1.6146 14.0735 1.32698 14.638C1 15.2798 1 16.1198 1 17.8V19M11.5 5.5C11.5 7.433 9.933 9 8 9C6.067 9 4.5 7.433 4.5 5.5C4.5 3.567 6.067 2 8 2C9.933 2 11.5 3.567 11.5 5.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutpatient);
export default __webpack_public_path__ + "static/media/outpatient.3225d62b7cd5621112ee083afee6fd55.svg";
export { ForwardRef as ReactComponent };